import "./boqInfo.css";
import {
  boqINFO,
  roofStructureData,
} from "../Design&Structure/structureFunction";

export default function SingleSelection({ roofDetail }) {
  const data = roofDetail;
  const structureItem = roofStructureData.find(
    (item) => item.name === data.mountingStructure
  );
  const boqItem = boqINFO[structureItem.name];

  return (
    <div className="boqInfoContainer">
      <>
        {boqItem.map((item, i) => (
          <ul className="boqTableBody" key={i}>
            <li>{item.serialNo}</li>
            <li>
              <img src={item.img} alt="images" ></img>
            </li>
            <li>{item.name}</li>
            <li>
              {
                //eslint-disable-next-line no-new-func
                Function("data", `return ${item.val}`)(data)
              }
            </li>
          </ul>
        ))}
      </>
    </div>
  );
}

